module.exports = __webpack_public_path__ + "img/Gemini.f902e0e4.png";